/**
 * DescriptionBackground component
 */
import Container from '@components/atoms/container/descriptionBackgroundContainer';
import LeftMask from '@components/atoms/mask/descriptionLeftMask';
import BottomMask from '@components/atoms/mask/descriptionBottomMask';
import { useAppSelector } from '@shared/store/hooks';
import { appSelector } from '@shared/store/slices/app.slice';

/**
 * This component displays the background and masks of the detail page.
 */
export default function DescriptionBackground() {
  const { status } = useAppSelector(appSelector);
  return (
    <Container display={status.description}>
      <BottomMask />
      <LeftMask />
    </Container>
  );
}
